var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"mt-2",attrs:{"title":_vm.$t('triggers_count_stat_title')}},[_c('vue-apex-charts',{attrs:{"type":"area","height":"400px","series":_vm.triggersStat.series,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }